"use strict";
/* globals module */
/**
 * @module skillClient
 * @description  Skill Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var SkillClient = /** @class */ (function () {
    function SkillClient(skillRoute, skillBatchClient, apiClient) {
        this.skillRoute = skillRoute;
        this.skillBatchClient = skillBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(SkillClient.prototype, "routeDefinition", {
        get: function () {
            return this.skillRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkillClient.prototype, "batch", {
        get: function () {
            return this.skillBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of skill resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example skillClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    SkillClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the skill resource.
     * @method
     * @param id Skill id which uniquely identifies skill resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example skillClient.get(id, options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    SkillClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.skillRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create skill action has been performed; this action creates a new skill resource.
     * @method
     * @param data A skill object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create skill action has been performed.
     * @example skillClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    SkillClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update skill action has been performed; this action updates a skill resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `skillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A skill object used to update specified skill resource.
     * @returns A promise that is resolved once the update skill action has been performed.
     * @example // skill is a resource previously fetched using get action.
                    skill.description = '<description>';
                    skillClient.update(skill)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    SkillClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a skill resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `skillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param A skill object used to delete specified skill resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // skill is a resource previously fetched using get action.
                       skillClient.remove(skill)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    SkillClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    SkillClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.SkillRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.SkillBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.SkillRoute !== "undefined" && _1.SkillRoute) === "function" ? _a : Object, typeof (_b = typeof _1.SkillBatchClient !== "undefined" && _1.SkillBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], SkillClient);
    return SkillClient;
}());
exports.SkillClient = SkillClient;
